import Styled from 'styled-components';

import { FormCaption } from './FormCaption';

export const FormError = Styled(FormCaption)`
  color: ${props => props.theme.brand.colorAlert};
  line-height: 1.4;
`;

FormError.displayName = 'FormError';

export default FormError;
